export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8456.63a5293f.jpg";